import {Action, handleActions} from "redux-actions";
import {DEFAULT_RESEARCH_PAGINATION, IResearchPageState} from "../../model/ResearchPageState.model";
import {ResearchPageActionTypes} from "./ResearchPageActions";

export const initialState: IResearchPageState = {
    facetedFilters: {},
    searchText: "",
    pagination: DEFAULT_RESEARCH_PAGINATION,
    scrollToBackstopId: undefined,
};

const updateFacetedFilters = (state: IResearchPageState, action: Action<IResearchPageState>): IResearchPageState => {
    return {
        ...state,
        facetedFilters: action.payload ? action.payload.facetedFilters : initialState.facetedFilters,
        pagination: {...state.pagination, pageIndex: 0},
    };
};

const updateSearchText = (state: IResearchPageState, action: Action<IResearchPageState>): IResearchPageState => {
    return {
        ...state,
        searchText: action.payload ? action.payload.searchText : initialState.searchText,
        pagination: {...state.pagination, pageIndex: 0},
    };
};

const updatePagination = (state: IResearchPageState, action: Action<IResearchPageState>): IResearchPageState => {
    return {
        ...state,
        pagination: action.payload ? action.payload.pagination : initialState.pagination,
    };
};

const setScrollToBackstopId = (state: IResearchPageState, action: Action<IResearchPageState>): IResearchPageState => {
    return {
        ...state,
        scrollToBackstopId: action.payload ? action.payload.scrollToBackstopId : initialState.scrollToBackstopId,
    };
};

const clearAllFilters = (state: IResearchPageState): IResearchPageState => {
    return {
        ...state,
        facetedFilters: {},
        searchText: "",
        pagination: {...state.pagination, pageIndex: 0},
    };
};

const reducerMap = {
    [ResearchPageActionTypes.UPDATE_RESEARCH_FACETED_FILTERS]: updateFacetedFilters,
    [ResearchPageActionTypes.UPDATE_RESEARCH_SEARCH_TEXT]: updateSearchText,
    [ResearchPageActionTypes.UPDATE_RESEARCH_PAGINATION]: updatePagination,
    [ResearchPageActionTypes.SET_RESEARCH_SCROLL_TO]: setScrollToBackstopId,
    [ResearchPageActionTypes.CLEAR_ALL_RESEARCH_FILTERS]: clearAllFilters,
};

export default handleActions<IResearchPageState, any>(reducerMap, initialState);
